import { mapGetters } from 'vuex'
import format from '@/module/util/format'

export default {

	props: {
		row: {
			type: Object
		}
	},

	computed: {
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		])
	},

	methods: {
		...format
	}
}
